exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ipoint-success{margin-top:80px}.ipoint-success-content{width:80%;margin:0 auto;background-color:#fff;padding:50px 150px;margin-bottom:200px}.ipoint-success-content p{font-size:24px;color:#5e6d82;letter-spacing:0}.ipoint-success-content .ipoint-remaining{font-size:46px;color:#1f2d3d;letter-spacing:0}.ipoint-success-content .ipoint-continue-shopping{font-size:16px;color:#0084ff;display:block}.ipoint-success-content .ipoint-continue-shopping>i{vertical-align:middle}@media screen and (max-width:768px){.ipoint-success .ipoint-success-content{width:100%;padding:5%;margin:0}}@media screen and (max-width:414px){.ipoint-success .ipoint-success-content{padding-top:100px}.ipoint-success .ipoint-success-content img{width:25%}.ipoint-success .ipoint-success-content p{font-size:28px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1e1863e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profiler/iPointSuccess.vue
// module id = 408
// module chunks = 0